























































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, IResource, ObjectCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySacGuest from '@/components/filters/FilterDeliverySacPublic.vue'
import DeliverySacPublicRequest from '@/model/request/DeliverySacPublicRequest'
import FilterToggle from '@/components/FilterToggle.vue'
import itTrackingSlider from '@/components/itrack/ItTrackingSlider.vue'
import * as Helper from '@/helpers'
import {SacFilterType} from '@/enums/SacFilterType'
import _ from 'lodash'

const metaInfo = () => ({
  title: $.t('view.reports.deliverySacPublic.title'),
})

@Component({
  metaInfo,
  components: {FilterDeliverySacGuest, FilterToggle, itTrackingSlider},
})
export default class ReportsDeliverySacPublicView extends Mixins(MixinFilter) {
  SacFilterType = SacFilterType

  filter = new DeliverySacPublicRequest()

  type: IResource | null = null
  options = new ObjectCollection(SacFilterType, 'enums.SacFilterType')
    .prependNull('view.reports.deliverySacPublic.selectDocType')

  @Watch('type', {deep: true})
  typeEvent() {
    this.filter = new DeliverySacPublicRequest()
  }

  submit() {
    if (!this.filter.isCleared) {
      const query = Helper.classToPlain(this.filter) as any

      if (query.danfe) {
        query.danfe = (_.chunk(query.danfe, 4) as string[][])
          .map((item: string[]) => item.join(''))
          .join(' ')
        // Formata a danfe em #### #### #### #### #### #### #### #### #### #### ####
        // para que a url não entenda esta sequencia de digítos como number e converter para notação científica
      }

      this.$router.push({
        path: '/sac/cnhIveco/result',
        query,
      })
    }
  }
}
